import {
  TableContainer,
  Th,
  Thead,
  useDisclosure,
  Menu,
  MenuButton,
  Box,
  Input,
  MenuList,
  MenuItem
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Link, useLocation } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { useApi } from '../../../context/ApiProvider';
import { useSideNavContext } from '../../../context/SideNavProvider';
import CustomAlert from '../../CustomAlert/CustomAlert';
import { DataTable } from '../../DataTable/DataTable';
import IconComponent from '../../IconComponent/IconComponent';
import { SuperAdminListingUser, SimpleTenant} from '../../../shared/type/super-admin-users.type';

const columnHelper = createColumnHelper<SuperAdminListingUser>();

const AllUsers = () => {
  const location = useLocation();
  const { toggleShowNav } = useSideNavContext();
  const { apiSuperAdminUserController } = useApi();
  const { isOpen, onClose } = useDisclosure();
  const [userData, setUserData] = useState<SuperAdminListingUser[] | []>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchPhrase, setSearchPhrase] = useState('');
  const [debouncedSearchPhrase, setDebouncedSearchPhrase] = useState(searchPhrase);

  const columns = [
    columnHelper.accessor('id', {
      cell: (info) => info.getValue(),
      header: 'ID'
    }),
    columnHelper.accessor('firstName', {
      cell: (info) => {
        const { id, lastName, firstName } = info.row.original;
        return <div className="text-sm font-medium">{firstName} {lastName}</div>;
      },
      header: 'Nazwa'
    }),
    columnHelper.accessor('email', {
      cell: (info) => {
        const email = info.getValue();
        return <div className="text-sm font-medium">{email}</div>;
      },
      header: 'Email'
    }),
    columnHelper.accessor('roleName', {
      cell: (info) => {

        const { roleName } = info.row.original;
        return <div className="text-sm font-medium">{roleName}</div>;
      },
      header: 'Rola'
    }),
    columnHelper.accessor('archive', {
      cell: (info) => {
        const archive = info.getValue();
        return <div className="text-sm font-medium">{archive}</div>;
      },
      header: 'Archiwalny'
    }),
    columnHelper.accessor('tenants', {
      cell: (info) => {
        const { id,tenants,roleName } = info.row.original;
        const getPath = (tenantId: number, userId: number, roleName: string): string => {
          if (roleName === 'PARENT') {
            return location.pathname.replace(
              'all-users',
              `branches/id/${tenantId}/users/parents/single-parent/${userId}/parent-data`
            );
          }
          if (roleName === 'TENANT_ADMIN') {
            return location.pathname.replace(
              'all-users',
              `branches/id/${tenantId}/users/administrators/single-administrator/${userId}/administrator-data`
            );
          }
          if (roleName === 'TEACHER') {
            return location.pathname.replace(
              'all-users',
              `branches/id/${tenantId}/users/teachers/single-teacher/${userId}/teacher-data`
            );
          }
          if (roleName === 'EMPLOYEE') {
            return location.pathname.replace(
              'all-users',
              `branches/id/${tenantId}/users/employees/single-employee/${userId}/employee-data`
            );
          }

          // fallback path if role is not matched
          return location.pathname;
        };
        return (
          <div>
            <ul className="flex flex-col">
              {tenants.map((tenant) => (
                <li
                  key={tenant.id}
                  className="text-sm font-medium text-grayLight-900 underline underline-offset-4">
                  <Link to={getPath(tenant.id, id,roleName)}>
                    {tenant.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        );
      },
      header: 'Oddziały'
    })
  ];

  const fetchUsers = async () => {
    try {
      console.warn('user fetch');
      const response: AxiosResponse<any, SuperAdminListingUser[]> =
        await apiSuperAdminUserController('list').get('',
          {
            params: { "searchPhrase": debouncedSearchPhrase }
          }
        );
      return response.data;
    } catch (error) {
      console.warn(error);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const userData = await fetchUsers();
      setUserData(userData);

    } catch (error) {
      console.warn(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
    fetchData();
  };

    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedSearchPhrase(searchPhrase);
      }, 400);

      return () => {
        clearTimeout(handler);
      };
    }, [searchPhrase]);

    useEffect(() => {
         toggleShowNav(true);
         fetchData();
    }, [debouncedSearchPhrase]);

  return (
    <div className="Branches__tableContainer h-full flex flex-col justify-start lg:p-spacing-4xl">
      <TableContainer
        h={800}
        overflowY="scroll"
        className="lg:p-spacing-3xl  bg-white rounded-lg">
        <DataTable
          data={userData}
          columns={columns}
          isLoading={isLoading}
          hideSearch={true}
          extraThead={
            <Thead>
              <Th colSpan={columns.length}>
                <div className="w-full flex items-center justify-between">
                  <p className="text-base font-semibold">Lista użytkowników</p>
                </div>
                <Input
                  value={searchPhrase}
                  onChange={(e) => setSearchPhrase(e.target.value)}
                  placeholder="Szukaj..."
                />
              </Th>
            </Thead>
          }
        />
      </TableContainer>
    </div>
  );
};

export default AllUsers;
